import { ChartDataAdapter } from 'src/components/BeaconRedesignComponents/ExperimentalLayout/ContentV2/Summary/Visualizations/adapters/types';
import { TimeSeriesData, TimeSeriesPoint } from './TimeSeriesData';

interface TimeSeriesAdapterData {
  primaryMetrics: TimeSeriesPoint[];
  secondaryMetrics: TimeSeriesPoint[];
}
export class TimeSeriesAdapter implements ChartDataAdapter<TimeSeriesAdapterData> {
  private primaryData: TimeSeriesData;

  private comparisonData: TimeSeriesData;

  private comparisonPeriod: string;

  constructor(primaryData: TimeSeriesData, comparisonData: TimeSeriesData, comparisonPeriod: string) {
    // Defensive copies to prevent mutation
    this.primaryData = primaryData.clone();
    this.comparisonData = comparisonData.clone();
    this.comparisonPeriod = comparisonPeriod;
  }

  public connectSeries(): TimeSeriesAdapter {
    if (!this.comparisonData.isValid()) {
      return this;
    }

    const lastComparisonPoint = this.comparisonData.getLastElement();
    const splicedData = this.primaryData.unshift(lastComparisonPoint);

    this.primaryData = splicedData;
    return this;
  }

  public convertTimeStampsToNextYear(): TimeSeriesAdapter {
    this.comparisonData = this.comparisonData.convertTimeToNextYear();
    return this;
  }

  public transform(): TimeSeriesAdapterData {
    // Note: Prior Period merging is handled by SplineChartV2's useSplineChartV2Data hook
    // So we don't call connectSeries() here anymore to avoid double-merging

    // Use toWeekIdSeries() for SplineChartV2 which uses category-based x-axis with weekIds
    return {
      primaryMetrics: this.primaryData.toWeekIdSeries(),
      secondaryMetrics: this.comparisonData.toWeekIdSeries()
    };
  }
}
